import React from 'react';
export function Guarantee() {
  return <section className="py-10 px-4 bg-white" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <div className="border-4 border-dashed border-gray-300 rounded-3xl p-6 md:p-10 flex flex-col md:flex-row items-center gap-6" data-id="element-44">
          <div className="flex-shrink-0 text-6xl" data-id="element-45">🛡️</div>
          <div className="text-center md:text-left" data-id="element-46">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 uppercase" data-id="element-47">
              🔒 GARANTÍA TOTAL
            </h2>
            <p className="text-lg text-gray-800 mb-1 font-bold" data-id="element-48">
              Probalo durante 7 días
            </p>
            <p className="text-base text-gray-700 mb-2" data-id="element-49">
              Si no sentís más claridad, tranquilidad o mejoras…
              <br data-id="element-50" />
              <span className="font-bold text-gray-900" data-id="element-51">
                👉 Te devolvemos el 100% del dinero
              </span>
            </p>
            <p className="font-bold text-gray-500 uppercase tracking-widest text-sm" data-id="element-52">
              Sin preguntas
            </p>
          </div>
        </div>
      </div>
    </section>;
}